import IService from '../IService';

/**
 * triggers global event 'story:autosave:progress'
 * to indicate when autosave in progress or not
 */
export default IService.extend({
  deflate: void 0,

  /**
   * @constructor
   * @param diffObject {object} output of _.diffObject function
   */
  StoryUpdateModel: function StoryUpdateModel(diffObject) {
    this.storyModel = {};
    this.fieldsNamesToUpdate = [];

    const fieldsToIgnore = [
      'template',
      // TODO: remove after merge of fb-new-vo to develop
      'comment',
      'comments',
      // TODO: remove those from StoryModel
      'links',
      'linksText',
      'linksAndLinksText',
    ];

    // @note: iteration order is not guaranteed
    // @note: the most recent value should be at index `0`
    _.each(diffObject, (value, key) => {
      if (fieldsToIgnore.indexOf(key) >= 0) {
        return true; // continue
      }
      this.storyModel[key] = value[0];
      this.fieldsNamesToUpdate.push(key);
    });
  },

  initialize: function () {
    this.$ajax = null;
    this.listenTo(this, 'package:sent', this._onPackageSent);
  },

  /**
   * If called multiple times - only last returned promise will be resolved!
   * @param storyModel {app.namespace.Model.StoryModel}
   * @param currentStoryData {object}
   * @param options
   * @return {$.Deferred} resolved with payload (currentStoryData, diffObject)
   */
  send: function (storyModel, currentStoryData, options) {
    this.options = $.extend(
      {
        showError: false,
      },
      options
    );
    this.deferred = new $.Deferred();

    if (app.xhrExpected(this.$ajax) || (this.mutex && this.mutex.isBusy())) {
      this._updatePackage(storyModel, currentStoryData);
    } else {
      this._package = this._preparePackage(storyModel, currentStoryData);
      this._sendPackage();
    }

    app.trigger('story:autosave:progress', { inProgress: true });
    this.deferred
      .fail(() => {
        app.trigger('story:autosave:progress', {
          inProgress: false,
          error: true,
        });
      })
      .done(() => {
        app.trigger('story:autosave:progress', {
          inProgress: false,
          error: false,
        });
      });

    return this.deferred.promise();
  },

  _preparePackage: function (storyModel, currentStoryData) {
    const autosaveStore = storyModel.modelState.get('autosaveStore');
    const diffObject = _.diffObject(currentStoryData, autosaveStore);

    const storyUpdateModel = new this.StoryUpdateModel(diffObject);
    return {
      id: Date.now(),
      storyId: storyModel.id,
      currentStoryData: currentStoryData,
      storyUpdateModel: storyUpdateModel,
    };
  },

  _updatePackage: function (storyModel, currentStoryData) {
    this._package = this._preparePackage(storyModel, currentStoryData);
  },

  _sendPackage: IService.synchronized(function () {
    const currentPackage = $.extend(true, {}, this._package);
    const promise = new $.Deferred();

    this.$ajax = $.ajax({
      url: app.apiUrl(`/api/v1/draftStories/${currentPackage.storyId}`),
      type: 'PATCH',
      // @note: allowing to override this ajax prop by
      // @example: app.api.draftStoriesAutosave.deflate = false
      deflate: this.deflate,
      timeout: app.TIME.minute(5),

      contentType: 'application/json',
      data: JSON.stringify(currentPackage.storyUpdateModel),

      error: (jqXHR, textStatus, errorThrown) => {
        if (jqXHR.status === 401) {
          // ignore lost authentication
        } else if ('abort' === errorThrown) {
          // ignore xhr aborts
        } else {
          this.deferred.reject(this.createError(jqXHR));
        }
        promise.reject(jqXHR, errorThrown);
      },

      success: () => {
        // @note: trigger is synchronous, entering recursion
        this.trigger('package:sent', currentPackage);
        promise.resolve();
      },
    }).always(() => {
      this.$ajax = null;
    });

    return promise;
  }),

  _onPackageSent: function (sentPackage) {
    if (this._package.id > sentPackage.id) {
      this._sendPackage();
    } else {
      if (app.sudo.autosave.override && app.sudo.autosave.failure) {
        this.deferred.reject({
          error: 'override',
        });
        return;
      }

      this.deferred.resolve(sentPackage);
    }
  },
});
